import { BusinessType } from 'core/domicile';

export const getGenderDescription = (sex: string): string => {
  const genders = {
    M: 'Masculino',
    F: 'Femenino',
  };

  return genders[sex?.toUpperCase()];
};

export const getBusinessType = (pathname: string): BusinessType => {
  if (pathname.includes('/claro-tv')) {
    return BusinessType.TV;
  }
  return BusinessType.FIJO;
};

export const isFijoBusinessType = (businessType: string): boolean => {
  return BusinessType.FIJO === businessType;
};

export const isTVBusinessType = (businessType: string): boolean => {
  return BusinessType.TV === businessType;
};
